// https://www.dbos.dev/agentic-ai-builder-early-access

import { SiteLayout } from '@components/layout/SiteLayout';
import { FooterCtaBuildYourReliableBackend } from '@components/layout/FooterCtas';
import { ScriptEmbed } from '@components/webflow';

export function AgenticAiBuilderEarlyAccessPage() {
  return (
    <SiteLayout banner={true} footerCta={<FooterCtaBuildYourReliableBackend />}>
      <style
        dangerouslySetInnerHTML={{
          __html:
            "form#hsForm_f78959e7-8218-449d-8ba2-aa4500a40cf8 label {\ncolor: var(--color-palette--color-neutral-500) !important;\nfont-family: var(--sizing--text-font-body), 'Helvetica Neue', sans-serif !important;\nfont-size: var(--sizing--sizing-400) !important;\n\n}",
        }}
      />
      <section className="hero-col-2">
        <div className="w-layout-hflex hero-col-left">
          <div className="hero-heading">
            <h1 className="text-heading-h1">Build Resilient AI Agents with DBOS</h1>
            <div className="text-heading-h1 text-heading-blur">
              {'The '}
              <span className="text-gradient">easiest</span>
              {' way to build cloud-native backends'}
            </div>
          </div>
          <div className="text-body">
            Thank you for your interest in DBOS for agentic AI workflows.
            <br />
            <br />
            {
              'With so much depending on the correctness of your AI automation, DBOS gives you an easy way to make sure that your agentic AI\u00a0\u00a0workflows are:'
            }
            <br />- Failure-proof
            <br />- Fully observable
            <br />- Performant and cost-effective to run
            <br />
            <br />
            {
              'DBOS is a great platform for executing AI automation workflows that are resilient to failures, transparent, and easy to build.\u00a0\u00a0'
            }
            <br />
            <br />
            {
              'Please register to request a meeting to learn how DBOS works with Agentic AI frameworks and harnesses to ensure agent reliability and observability. '
            }
          </div>
        </div>
        <div className="w-layout-hflex hero-col-right">
          <h2 className="text-heading-h2">Get started</h2>
          <div className="text-body">
            {'Sign up below to receive details on durable agentic AI workflows with open source DBOS. '}
          </div>
          <ScriptEmbed
            className="embedded-form w-embed w-script"
            html={
              '<script charset="utf-8" type="text/javascript" src="//js.hsforms.net/forms/embed/v2.js"></script>\n<script>\n  hbspt.forms.create({\n    portalId: "45237820",\n    formId: "6519f935-43d1-4c39-b74e-00a3b6b2e1b9"\n  });\n</script>'
            }
          />
        </div>
      </section>
    </SiteLayout>
  );
}
